import { useTranslate } from "ra-core";
import { AuthLayout } from "./AuthLayout";
import { authTextClassName } from "./authStyles";

export const ConfirmationRequired = () => {
  const translate = useTranslate();

  return (
    <AuthLayout
      title={translate("crm.auth.welcome_title", {
        _: "Welcome to Atomic CRM",
      })}
    >
      <p className={`text-center ${authTextClassName}`}>
        {translate("crm.auth.confirmation_required", {
          _: "Please follow the link we just sent you by email to confirm your account.",
        })}
      </p>
    </AuthLayout>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
